import { RadioGroup } from "@mui/material";
import styled from "styled-components";

export const RadioGroupContainer = styled(RadioGroup)`
    padding-left: 5px;
    width: 100%;
`